import { StyledCheckbox } from '@/components/styles'
import { useFormContext } from 'react-hook-form'

const Checkbox = props => {
  const { name, defaultChecked, children = [] } = props
  const { register } = useFormContext()
  const id = `${name}-checkbox`

  return (
    <StyledCheckbox>
      <StyledCheckbox.Input
        id={id}
        type="checkbox"
        name={name}
        ref={register}
        defaultChecked={defaultChecked}
      />
      <StyledCheckbox.Label htmlFor={id}>{children}</StyledCheckbox.Label>
    </StyledCheckbox>
  )
}

export default Checkbox
